import { z } from "zod";

export const userWorkspaceRoleSchema = z
  .enum(["owner", "member", "viewer"])
  .describe("UserWorkspaceRole");

// Workspace params schema
export const workspaceParamsSchema = z
  .object({
    id: z.string(),
  })
  .describe("WorkspaceParams");

// Workspace payment method body schema
export const workspacePaymentMethodBodySchema = z
  .object({
    email: z.email(),
    workspaceId: z.uuid(),
  })
  .describe("WorkspacePaymentMethodBody");

// Workspace partnership agreement body schema
export const workspacePartnershipAgreementBodySchema = z
  .object({
    isAgreed: z.boolean(),
    workspaceId: z.uuid(),
  })
  .describe("WorkspacePartnershipAgreementBody");

// Workspace permissions body schema
export const workspacePermissionsBodySchema = z
  .object({
    usersToGrantAccess: z.array(
      z.object({
        role: userWorkspaceRoleSchema,
        email: z.email(),
      }),
    ),
  })
  .describe("WorkspacePermissionsBody");

// Workspace permissions resend body schema
export const workspacePermissionsResendBodySchema = z
  .object({
    email: z.email(),
  })
  .describe("WorkspacePermissionsResendBody");

// Workspace permissions update body schema
export const workspacePermissionsUpdateBodySchema = z
  .object({
    role: userWorkspaceRoleSchema,
    email: z.email(),
  })
  .describe("WorkspacePermissionsUpdateBody");

// Workspace permissions delete body schema
export const workspacePermissionsDeleteBodySchema = z
  .object({
    userId: z.uuid(),
  })
  .describe("WorkspacePermissionsDeleteBody");
